export type ErrorResponseType = {
  errorStatus: number;
  message: string;
  errorId: string;
};
export const defaultErrorText: string = 'Что-то пошло не так!';
